/**
 * Supplier correspondence messages, keyed by quoteId.
 * sender: 'coordinator' = logged-in user (right bubble, teal)
 * sender: 'supplier'    = supplier reply  (left bubble, grey)
 */
export const supplierMessages = [
  // sqr-001 — Vantage Technology Supply (Received): quick exchange after quote came in
  {
    id: 'sm-001',
    quoteId: 'sqr-001',
    sender: 'coordinator',
    senderName: 'Adam H.',
    text: 'Thanks for the quick turnaround. Can you confirm the shipping address would be our Dallas FSL?',
    sentAt: '2026-03-20T14:30:00.000Z',
  },
  {
    id: 'sm-002',
    quoteId: 'sqr-001',
    sender: 'supplier',
    senderName: 'R. Simmons (Vantage Tech)',
    text: 'Confirmed — we have your Dallas FSL on file. Ready to ship within 24hrs of PO receipt.',
    sentAt: '2026-03-20T15:12:00.000Z',
  },

  // sqr-003 — Bridgepoint Components (Pending): coordinator follow-up nudge, no reply yet
  {
    id: 'sm-003',
    quoteId: 'sqr-003',
    sender: 'coordinator',
    senderName: 'Adam H.',
    text: 'Following up on our RFQ sent 2026-03-18. Could you let us know availability for 5× RAM-32GB-DDR5? We have a time-sensitive customer request.',
    sentAt: '2026-03-21T09:00:00.000Z',
  },
];
